import React from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { Search, X } from 'lucide-react';

const SearchBar = ({ placeholder = 'Search...' }) => {
  const { searchQuery, setSearchQuery } = useAppState();

  return (
    <div className="search-bar" data-testid="search-bar">
      <Search size={18} className="search-icon" />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder={placeholder}
        className="search-input"
        data-testid="search-input"
      />
      {searchQuery && (
        <button
          onClick={() => setSearchQuery('')}
          className="search-clear"
          data-testid="search-clear-btn"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
